import type { ComponentType } from 'react';
import type { MetricRenderer } from '../types';
import type { MetricRendererProps } from '../components/renderers/rendererTypes';
import HeroRenderer, { HeroWithAlertRenderer } from '../components/renderers/HeroRenderer';
import StatCardRenderer, {
  StatCardWithBadgeRenderer,
  StatCardWithDotRenderer,
} from '../components/renderers/StatCardRenderer';
import StatWithDescriptionRenderer, {
  StatWithBreakdownRenderer,
} from '../components/renderers/StatWithDescriptionRenderer';
import BenchmarkGaugeRenderer from '../components/renderers/BenchmarkGaugeRenderer';
import RankedBreakdownRenderer from '../components/renderers/RankedBreakdownRenderer';
import DataTableRenderer from '../components/renderers/DataTableRenderer';
import VerticalBarChartRenderer from '../components/renderers/VerticalBarChartRenderer';
import SectionTitleMetricRenderer from '../components/renderers/SectionTitleMetricRenderer';

export const rendererMap: Record<MetricRenderer, ComponentType<MetricRendererProps>> = {
  hero: HeroRenderer,
  heroWithAlert: HeroWithAlertRenderer,
  statCard: StatCardRenderer,
  statCardWithDot: StatCardWithDotRenderer,
  statCardWithBadge: StatCardWithBadgeRenderer,
  statWithDescription: StatWithDescriptionRenderer,
  statWithBreakdown: StatWithBreakdownRenderer,
  benchmarkGauge: BenchmarkGaugeRenderer,
  rankedBreakdown: RankedBreakdownRenderer,
  dataTable: DataTableRenderer,
  verticalBarChart: VerticalBarChartRenderer,
  sectionTitleMetric: SectionTitleMetricRenderer,
};
